import { useSetAtom } from "jotai";
import { type ChangeEvent, useState } from "react";
import { widgetMenuOptionsAtom } from "@/interface/AppStore";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { applyValue, setNewOptions } from "../../lib";
import { RangeInput } from "../RangeInput/RangeInput";
import styles from "./LineTypeMenu.module.css";

interface LineWidthInputProps {
    initialWidth: number;
    options: widgetOption[];
}
export function LineWidthInput({ initialWidth, options }: LineWidthInputProps) {
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const [width, setWidth] = useState(initialWidth);

    const handleRangeChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = Number(event.currentTarget.value);

        const setNewLineTypeOptions = setNewOptions({ name: "lineType", setWidgetMenuOptions });

        setWidth(value);
        applyValue({ options, value: { lineWidth: value }, setNewOptions: setNewLineTypeOptions });
    };

    return (
        <RangeInput
            className={styles.range}
            min={1}
            max={15}
            step={1}
            value={width}
            name="lineWidth"
            onChange={handleRangeChange}
        />
    );
}
